import { render } from "./Outlet.vue?vue&type=template&id=df5f7828&lang=true"
import script from "./Outlet.vue?vue&type=script&lang=js"
export * from "./Outlet.vue?vue&type=script&lang=js"
script.render = render

export default script